module.exports = __webpack_public_path__ + "static/media/heart6.9859d4b1.svg";